import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  Typography,
} from "@mui/material";
import { InfoSquareOutline } from "@tiny/icons";

const REQUEST_ACCESS_FORM_URL = "https://8ixs6dwkrxj.typeform.com/to/OgtzuSTG";

interface FeatureNotAvailableDialogProps {
  open: boolean;
  onClose: () => void;
}

function FeatureNotAvailableDialog({
  open,
  onClose,
}: FeatureNotAvailableDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogContent sx={{ pt: 6, pb: 4, px: 4, textAlign: "center" }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            backgroundColor: "primary.lighter",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            mb: 3,
          }}
        >
          <InfoSquareOutline sx={{ fontSize: 32, color: "primary.main" }} />
        </Box>
        <Typography variant="h3" fontWeight={700} gutterBottom sx={{ mb: 2 }}>
          Feature Activation
        </Typography>
        <Typography
          variant="p2"
          sx={{ lineHeight: 1.6, maxWidth: 400, margin: "0 auto" }}
        >
          To activate this feature, please fill out the activation form and we
          will enable it for you within the next 24 hours.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{ px: 4, pb: 4, pt: 2, gap: 2, justifyContent: "center" }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ fontWeight: 600, px: 4, py: 1.25, borderRadius: 2 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            fontWeight: 600,
            px: 4,
            py: 1.25,
            borderRadius: 2,
            boxShadow: 2,
            "&:hover": { boxShadow: 4 },
          }}
          onClick={() =>
            window.open(
              REQUEST_ACCESS_FORM_URL,
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          Fill Form
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FeatureNotAvailableDialog;
